import React, { PureComponent } from 'react';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import {
  Grid,
  Chip,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { getTargetVehicleCounts, zobaHexColor, OpsZoneStatuses } from '../../../lib/utils';
import ValidatedNumberInput from '../../common/validated-number-input';

import Marker from './marker';

const ICON_WIDTH = 75;
const ICON_HEIGHT = 75;

const iconStyle = (zoneHexColor = '#3573A4', vehicleCount = 0, aggregateTarget = 0, inCurrentBuild = false, isRun = false, index = 0, overCapacity = false) => {
  const svgString = `
  <svg width="${ICON_WIDTH}" height="${ICON_HEIGHT}" viewBox="0 0 75 51" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <path d="M3.33333333,33.3333333 C1.49238417,33.3333333 0,31.8409492 0,30 L0,3.33333333 C0,1.49238417 1.49238417,0 3.33333333,0 L63.3333333,0 C65.1742825,0 66.6666667,1.49238417 66.6666667,3.33333333 L66.6666667,30 C66.6666667,31.8409492 65.1742825,33.3333333 63.3333333,33.3333333 L38.3333333,33.3333333 L33.3333333,40 L28.3333333,33.3333333 L3.33333333,33.3333333 Z" id="path-k9fs56jkpc-1"></path>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g>
        <g>
          ${overCapacity ? `<g fill-rule="nonzero">
            <path d="M7.33333333,37.3333333 C5.49238417,37.3333333 4,35.8409492 4,34 L4,7.33333333 C4,5.49238417 5.49238417,4 7.33333333,4 L67.3333333,4 C69.1742825,4 70.6666667,5.49238417 70.6666667,7.33333333 L70.6666667,34 C70.6666667,35.8409492 69.1742825,37.3333333 67.3333333,37.3333333 L42.3333333,37.3333333 L37.3333333,44 L32.3333333,37.3333333 L7.33333333,37.3333333 Z" id="path-esz6gyzwh6-1" fill="#000000"></path>
            <path d="M67.3333333,0 C69.3583774,0 71.1917107,0.820811292 72.5187831,2.1478836 C73.7774418,3.40654238 74.5804471,5.12063604 74.6601443,7.0216028 L74.6601443,7.0216028 L74.6666667,34 C74.6666667,36.0250441 73.8458554,37.8583774 72.5187831,39.1854497 C71.260128,40.4441048 69.5460406,41.2471091 67.6450805,41.3268102 L67.6450805,41.3268102 L44.3334361,41.3331964 L37.3333333,50.6666667 L30.3333333,41.3333333 L7.33333333,41.3333333 C5.30828925,41.3333333 3.47495592,40.512522 2.1478836,39.1854497 C0.889224828,37.926791 0.0862195444,36.2126973 0.00652239387,34.3117305 L0.00652239387,34.3117305 L0,7.33333333 C0,5.30828925 0.820811292,3.47495592 2.1478836,2.1478836 C3.40655763,0.889209579 5.12067757,0.0862000875 7.02167189,0.00651949756 L7.02167189,0.00651949756 L67.3333333,0 Z" id="path-esz6gyzwh6-1-copy-2" fill="#FFFFFF"></path>
            <path d="M67.3333333,1 C69.082235,1 70.6655684,1.70888248 71.8116763,2.85499039 C72.9577842,4.00109829 73.6666667,5.58443162 73.6666667,7.33333333 L73.6666667,7.33333333 L73.6666667,34 C73.6666667,35.7489017 72.9577842,37.332235 71.8116763,38.4783429 C70.6655684,39.6244509 69.082235,40.3333333 67.3333333,40.3333333 L67.3333333,40.3333333 L43.8333333,40.3333333 L37.3333333,49 L30.8333333,40.3333333 L7.33333333,40.3333333 C5.58443162,40.3333333 4.00109829,39.6244509 2.85499039,38.4783429 C1.70888248,37.332235 1,35.7489017 1,34 L1,34 L1,7.33333333 C1,5.58443162 1.70888248,4.00109829 2.85499039,2.85499039 C4.00109829,1.70888248 5.58443162,1 7.33333333,1 L7.33333333,1 L67.3333333,1 Z" id="path-esz6gyzwh6-1-copy" fill="#CC0000"></path>
          </g>` : ''}
          <g transform="translate(4.000000, 4.000000)">
            <mask id="mask-k9fs56jkpc-2" fill="white">
              <use xlink:href="#path-k9fs56jkpc-1"></use>
            </mask>
            <g id="path-esz6gyzwh6-1"></g>
            <g id="path-esz6gyzwh6-4-link" mask="url(#mask-k9fs56jkpc-2)" fill="${zoneHexColor}" fill-rule="nonzero">
              <rect id="path-esz6gyzwh6-4" x="0" y="0" width="66.6666667" height="40"></rect>
            </g>
          </g>
          <g transform="translate(4.000000, 4.000000)" stroke="#FFFFFF" stroke-width="0.833333333">
            <path d="M3.33333333,33.3333333 C1.49238417,33.3333333 0,31.8409492 0,30 L0,3.33333333 C0,1.49238417 1.49238417,0 3.33333333,0 L63.3333333,0 C65.1742825,0 66.6666667,1.49238417 66.6666667,3.33333333 L66.6666667,30 C66.6666667,31.8409492 65.1742825,33.3333333 63.3333333,33.3333333 L38.3333333,33.3333333 L33.3333333,40 L28.3333333,33.3333333 L3.33333333,33.3333333 Z" id="path-esz6gyzwh6-6"></path>
          </g>
        </g>
        <text y="26" x="27%" fill="#FFFFFF" fill-rule="nonzero" font-family="ArialMT" font-size="15" text-anchor="middle" font-weight="normal">
          ${vehicleCount}
        </text>
        <text y="26" x="72%" fill="#FFFFFF" fill-rule="nonzero" font-family="ArialMT" font-size="15" text-anchor="middle" font-weight="normal">
          ${aggregateTarget}
        </text>
        <g stroke-linecap="square" transform="translate(36.500000, 12.750000)" stroke="#FFFFFF" stroke-width="0.833333333">
          <g>
            <line x1="0.416666667" y1="0" x2="0.416666667" y2="15.8333333" id="Line"></line>
          </g>
        </g>
      </g>
      ${inCurrentBuild || isRun ? `<g transform="translate(25.000000, ${overCapacity ? '48.000000' : '43.000000'})">
        <rect stroke="#000000" fill="#FFFFFF" x="0.5" y="0.5" width="22" height="13" rx="2"></rect>
        <text x="15%" y="11" font-family="ArialMT" text-anchor="middle" font-size="11" font-weight="500" letter-spacing="0.159999996" fill="#000000">
          #${index + 1}
        </text>
      </g>` : ''}
    </g>
  </svg>`;
  return `data:image/svg+xml;base64,${window.btoa(svgString)}`;
};

const warehouseIcon = (zoneHexColor) => {
  const homeIcon = `
  <svg width="${ICON_WIDTH}" height="${ICON_HEIGHT}" viewBox="0 0 96 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Warehouse</title>
      <defs>
          <path d="M4,40 C1.790861,40 -1.73547709e-16,38.209139 0,36 L0,4 C-2.705415e-16,1.790861 1.790861,-3.82769592e-17 4,0 L76,0 C78.209139,-4.05812251e-16 80,1.790861 80,4 L80,36 C80,38.209139 78.209139,40 76,40 L46,40 L40,48 L34,40 L4,40 Z" id="path-1"></path>
          <filter x="-16.2%" y="-22.9%" width="132.5%" height="154.2%" filterUnits="objectBoundingBox" id="filter-3">
              <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
              <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
          </filter>
          <rect id="path-4" x="0" y="0" width="80" height="48"></rect>
          <path d="M4,40 C1.790861,40 -1.73547709e-16,38.209139 0,36 L0,4 C-2.705415e-16,1.790861 1.790861,-3.82769592e-17 4,0 L76,0 C78.209139,-4.05812251e-16 80,1.790861 80,4 L80,36 C80,38.209139 78.209139,40 76,40 L46,40 L40,48 L34,40 L4,40 Z" id="path-6"></path>
      </defs>
      <g id="Warehouse" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(8.000000, 6.000000)">
              <g id="BG">
                  <mask id="mask-2" fill="white">
                      <use xlink:href="#path-1"></use>
                  </mask>
                  <g id="Rectangle-2" fill="black" fill-opacity="1">
                      <use filter="url(#filter-3)" xlink:href="#path-1"></use>
                  </g>
                  <g id="Hub/Color/Current/4F9D69" mask="url(#mask-2)">
                      <mask id="mask-5" fill="white">
                          <use xlink:href="#path-4"></use>
                      </mask>
                      <use id="Rectangle" fill="${zoneHexColor}" xlink:href="#path-4"></use>
                  </g>
                  <mask id="mask-7" fill="white">
                      <use xlink:href="#path-6"></use>
                  </mask>
                  <use id="Rectangle-2" stroke="#FFFFFF" xlink:href="#path-6"></use>
              </g>
              <g id="home" transform="translate(24.000000, 8.000000)" fill="#FFFFFF" fill-rule="nonzero">
                  <polygon id="Combined-Shape" points="13.3333333 23 6 23 6 11.1714286 0 11.1714286 16 0 32 11.1714286 26 11.1714286 26 23 18.6666667 23 18.6666667 13.8 13.3333333 13.8"></polygon>
              </g>
          </g>
      </g>
  </svg>`;
  return `data:image/svg+xml;base64,${window.btoa(homeIcon)}`;
};

// this weird function is from the docs, and ensures
// that the overlay is centered where you want it
// from : https://tomchentw.github.io/react-google-maps/#overlayview
// with one notable difference, removing the /2 from height.
// from here: https://stackoverflow.com/questions/19032243/google-maps-custom-overlay-position-moving
const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height),
});

function Vehicles({ vehiclesList }) {
  const brand = vehiclesList[0];
  const brandVehicles = vehiclesList[1] || [];
  const brandCount = brandVehicles.length || 0;

  return (
    <Grid>
      <Typography variant="caption">{`${brand}: ${brandCount}`}</Typography>
      {brandVehicles.map((vehicle) => (
        <Chip key={vehicle._id} label={vehicle.humanId} />
      ))}
    </Grid>
  );
}

class LocationMarker extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      newTarget: get(props, 'location.targetVehicleCounts.link', 0),
    };
  }

  get coordinates() {
    const { location } = this.props;
    return get(location, 'geo.coordinates', null);
  }

  get markerProps() {
    const {
      location,
      zIndex,
      activeLocations = [],
      isBuildingRoute = false,
      isRun = false,
      currentRoute = {},
      locationIndex = 0,
    } = this.props;
    const {
      vehicleIds = [], targetVehicleCounts, dynamicRouteIds, zones, hubCapacity,
    } = location;

    let zoneHexColor = '#3573A4';
    if (dynamicRouteIds && dynamicRouteIds.length) {
      zoneHexColor = zobaHexColor;
    } else {
      for (let i = 0, len = zones.length; i < len; i++) {
        const { status, hexColor } = zones[i];
        if (status === OpsZoneStatuses.ACTIVE && hexColor) {
          zoneHexColor = hexColor;
          break;
        }
      }
    }

    const { coordinates } = this;
    const aggregateTarget = getTargetVehicleCounts(targetVehicleCounts);
    const overCapacity = vehicleIds.length > hubCapacity;

    let z = overCapacity ? zIndex + 1 : zIndex;
    const inCurrentBuild = isBuildingRoute && activeLocations.includes(location);

    const fullOpacity = inCurrentBuild || !isBuildingRoute;
    if (inCurrentBuild) {
      zoneHexColor = currentRoute.hexColor;
      z += 1;
    } else if (isBuildingRoute && currentRoute.locations.includes(location._id)) {
      // if removing from current route, show the default blue color
      zoneHexColor = '#3573A4';
    }

    return {
      markerStyle: location.isWarehouse === true
        ? warehouseIcon(zoneHexColor)
        : iconStyle(
          zoneHexColor,
          vehicleIds.length,
          aggregateTarget,
          inCurrentBuild,
          isRun,
          locationIndex,
          overCapacity,
        ),
      key: get(location, '_id', 0),
      position: { lat: coordinates[1], lng: coordinates[0] },
      infoItemId: `location-${location._id}`,
      zIndex: z,
      opacity: fullOpacity ? 1 : 0.6,
    };
  }

  get renderInfoWindow() {
    const { location, onUpdateLocationTarget, readOnly = false } = this.props;
    const { newTarget } = this.state;

    const {
      name, type, vehicleIds = [], vehicles, hubCapacity,
    } = location;
    const newLocation = { ...location, targetVehicleCounts: { link: newTarget } };
    const vehiclesByBrand = groupBy(vehicles, 'brand');
    const vehiclesByBrandArray = Object.entries(vehiclesByBrand);

    return (
      <>
        <br />
        <Typography variant="h6">
          {type}
          :
          {' '}
          {name}
        </Typography>
        <Typography variant="body2">
          {`Max Vehicles: ${hubCapacity || ''}`}
        </Typography>
        {!readOnly && (
          <>
            <Typography variant="body2">Target Vehicles</Typography>
            <ValidatedNumberInput
              onChange={(newTargetValue) => this.setState({ newTarget: newTargetValue })}
              value={newTarget.toString()}
            />
          </>
        )}
        <Typography variant="body2">
          {`Vehicles Present: ${vehicleIds.length}`}
        </Typography>
        {vehiclesByBrandArray.map((entry) => (
          <Vehicles vehiclesList={entry} key={entry[0]} />
        ))}
        {!readOnly && (
          <DialogActions>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={() => {
                onUpdateLocationTarget(newLocation, location._id);
              }}
            >
              Save
            </Button>
          </DialogActions>
        )}
      </>
    );
  }

  render() {
    const { location, onClick, isSelected } = this.props;

    if (this.coordinates) {
      return (
        <Marker
          key={location._id}
          marker={this.markerProps}
          renderExtraInfo={() => this.renderInfoWindow}
          isSelected={isSelected}
          onClick={() => onClick(location)}
          anchor={getPixelPositionOffset(ICON_WIDTH, ICON_HEIGHT)}
        />
      );
    } else {
      return null;
    }
  }
}

export default LocationMarker;
